// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"239":"6470a508","488":"8a037500","732":"a9749de5","977":"6a82ee50"}[chunkId] + ".chunk.js");